module.exports = __webpack_public_path__ + "static/media/appstore.b37fbda5.svg";